e.SSO.two_factor = {
	url : config.api + 'sso',
	steps : {},
	phone : {},
	code : {},
	verify_fail : {},
	trust : {},

	init : function(){
		_.bindAll( this, '_send_verification_code', '_check_verification_code', '_send_ajax_request', '_maybe_trust_computer', '_verify_login', '_remove_all_trusted_devices' );

		//used for both verify-login and 2 factor auth
		this.steps = $( '#two-factor-steps' ).find( '.step' );
		this.phone = $( '#two-factor-phone' );
		this.code = $( '#two-factor-verification-code' );
		this.verify_fail = $( '#two-factor-verify-fail' );
		this.trust = $( '#two-factor-trust' );

		if( this.steps.length ){
			$( '#two-factor-send-verification' ).click( this._send_verification_code );
			$( '#two-factor-verify' ).click( this._check_verification_code );
			$( '#two-factor-trust-submit' ).click( this._maybe_trust_computer );
			$( '#two-factor-active' ).click( this._activate_two_factor );
			this._init_steps();
		}

		$( '#two-factor-deactivate' ).click( this._deactivate_two_factor );
		$( '#two-factor-remove-all-trusted' ).click( this._remove_all_trusted_devices );

		//verify-login form
		$( '#two-factor-verify-login-verify' ).click( this._verify_login );
	},

	/**
	 * Kill all keys mapped to cookies so all computers become no longer
	 * trusted
	 *
	 *
	 * @private
	 */
	_remove_all_trusted_devices : function(){
		this._send_ajax_request( 'remove_all_trusted_devices', {}, function( r ){
			if( true == r.success ){
				var $message = $( '#two-factor-remove-trusted-message' );
				$message.text( r.data );
				$message.show();
			}
			// @ifdef DEBUG
			console.info( r );
			// @endif
		});
	},


	/**
	 * Check a verification code from the /verify-login screen.
	 * If it matches PHP will log the user in, and we should redirect
	 * them to the original location.
	 * If it fails, display an error.
	 *
	 * Before we redirect we must set the trust this computer cookie if it is checked
	 *
	 *
	 * @private
	 */
	_verify_login : function(){
		var $code = this.code.val();
		if( $code != '' ){
			this.code.removeClass( 'error' );

			this._send_ajax_request( 'verify_login', {code : $code}, function( r ){
				if( true == r.success ){
					e.SSO.two_factor.verify_fail.text('');

					//if we have trust this computer checked we need to set the cookie before redirect
					if( true == e.SSO.two_factor.trust.prop( 'checked' ) ){
						e.SSO.two_factor._send_ajax_request( 'trust_computer', {}, function( r ){
							e.fn.setCookie( config.two_factor.cookie_name, r.data, config.two_factor.cookie_length );
							window.location.href = $( '#redirect_to' ).val();
						});
					} else {
						window.location.href = $( '#redirect_to' ).val();
					}

				} else {
					e.SSO.two_factor.code.addClass( 'error' );
					e.SSO.two_factor.verify_fail.text( r.data );
				}
			} );

		} else {
			//empty code
			this.verify_fail.text('');
			this.code.addClass( 'error' );
		}
	},


	/**
	 * Each time someone clicks the start button we deactive the
	 * two factor authentication for them
	 *
	 * @private
	 */
	_deactivate_two_factor : function(){
		e.SSO.two_factor._send_ajax_request( 'deactivate_two_factor', {} );
	},


	/**
	 * Send button clicked so tell the backend to
	 * generate a code and send it to the number
	 * specified.
	 *
	 *
	 * @param ev
	 * @private
	 */
	_send_verification_code : function( ev ){
		var $phone = this.phone.val();
		if( $phone == '' ){
			this.phone.addClass( 'error' );
			return false;

		} else {
			this.phone.removeClass( 'error' );
			this._update_variable_phones();
			this._move_step( 3 );

			this._send_ajax_request( 'send_verification_code', { phone : $phone } );
		}

	},


	/**
	 * Check the entered verification code to see if it matches
	 * the current code for the logged in user.
	 *
	 * If fails display the error message. If passes move
	 * on to step 4
	 *
	 * @private
	 */
	_check_verification_code : function(){
		var $code = this.code.val();
		if( $code != '' ){
			this.code.removeClass( 'error' );

			this._send_ajax_request( 'check_verification_code', {code : $code}, function( r ){
				if( true == r.success ){
					e.SSO.two_factor._move_step( 4 );
					e.SSO.two_factor.verify_fail.text('');
				} else {
					e.SSO.two_factor.code.addClass( 'error' );
					e.SSO.two_factor.verify_fail.text( r.data );
					$( '#two-factor-didnt-get-code' ).addClass( 'highlight' );
				}
			} );

		} else {
			//empty code
			this.verify_fail.text('');
			this.code.addClass( 'error' );
			$( '#two-factor-didnt-get-code' ).addClass( 'highlight' );
		}
	},

	/**
	 * If we checked the box to trust the computer
	 * send a request to retrieve a code and set
	 * to to a cookie based on config params
	 *
	 * @private
	 */
	_maybe_trust_computer : function(){
		if( true == this.trust.prop( 'checked' ) ){
			this._send_ajax_request( 'trust_computer', {}, function( r ){
				if( true == r.success ){
					e.fn.setCookie( config.two_factor.cookie_name, r.data, config.two_factor.cookie_length );
				}
			});
			e.SSO.two_factor._move_step( 5 );
		}
	},

	/**
	 * If they make it through all steps and click the confirm button
	 * at the end.
	 *
	 * We active 2 factor and redirect them to either /dashboard/sso or
	 * their default dashboard screen depending on if edspire-service-provider
	 * is active or not
	 *
	 * @private
	 */
	_activate_two_factor : function(){
		e.SSO.two_factor._send_ajax_request( 'activate_two_factor', {}, function( r ){
			if( true == r.success ){
				window.location.href = r.data;
			}
		});
	},


	/**
	 * Update any elements with class .variable-phone
	 * with the number provided
	 *
	 */
	_update_variable_phones : function(){
		var $phone = this.phone.val();
		$phone = $phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');

		$( '.variable-phone' ).text( $phone );
	},


	/**
	 * Fade out and fade in step that matches the data-step
	 * based on any element with the class .step-nav and
	 * data-step
	 *
	 * So clicking a link class="step-nav" data-step="2" will
	 * show the element with class="step" and data-step="2"
	 *
	 * @private
	 */
	_init_steps : function(){
		this.steps.not( '[data-step="1"]' ).hide();
		this.steps.find( '.step-nav' ).click( function(){
			var $nav = $( this );
			var $step = $nav.data( 'step' );
			e.SSO.two_factor._move_step( $step );
		});
	},

	/**
	 * Show given step and hide the rest
	 *
	 * @param $step
	 * @private
	 */
	_move_step : function( $step ){
		e.SSO.two_factor.steps.fadeOut( 300 );
		//do id separate so it does not run 4 times
		setTimeout( function(){
			// @ifdef DEBUG
			console.info( 'Displaying step ' + $step + '...' );
			// @endif
			e.SSO.two_factor.steps.filter( '[data-step="' + $step + '"]' ).fadeIn( 300 );
		}, 300 );

	},

	/**
	 * Send a request to Dashboard\SSO\Ajax
	 *
	 * @param {string} $method
	 * @param {object} $data
	 * @param {method} func - method to call upon completion
	 * @private
	 */
	_send_ajax_request : function( $method, $data, func ){
		$data.method = $method;

		if( 'undefined' == typeof( func ) ){
			func = function( r ){
				// @ifdef DEBUG
				console.info( r );
				// @endif
			}
		}

		$.post( this.url, $data, func );
	}

};